import { render, staticRenderFns } from "./ContentTab.vue?vue&type=template&id=861c6fa2&scoped=true&"
import script from "./ContentTab.vue?vue&type=script&lang=js&"
export * from "./ContentTab.vue?vue&type=script&lang=js&"
import style0 from "./ContentTab.vue?vue&type=style&index=0&id=861c6fa2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861c6fa2",
  null
  
)

export default component.exports